/**
 * Brand mark.
 *
 * The source PNG is 947x702 ARGB — near-square, not a wordmark — so it is
 * constrained by height and centred. Scaling it to fill a wide header would
 * stretch it; letting it size itself would let a 702px-tall image push the
 * layout around on first paint.
 */

export function BrandMark({ size = 40 }: { size?: number }) {
  return (
    <img
      className="brand-mark"
      src="/brand/mib-technology-logo.png"
      alt="MIB Technology"
      width={size}
      height={Math.round((size * 702) / 947)}
      loading="eager"
      decoding="async"
    />
  );
}
